module.exports = __webpack_public_path__ + "static/img/5.71cc269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p6/5.png
// module id = fr4o
// module chunks = 1